(function () {
  'use strict';

  var syncTimer = null;
  var isSyncInProgress = false;
  var syncQueued = false;
  var handlersBound = false;

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function getManualGwpMax(promoNo, tierNo) {
    var maxByPromo = window.jscManualGwpMax || {};
    var promoConfig = maxByPromo[String(promoNo)];
    var tierKey = String(tierNo || '1');

    if (promoConfig && typeof promoConfig === 'object') {
      var tierMax = parseInt(promoConfig[tierKey], 10);
      if (!Number.isNaN(tierMax) && tierMax >= 1) {
        return tierMax;
      }
    }

    var flatMax = parseInt(promoConfig, 10);
    if (!Number.isNaN(flatMax) && flatMax >= 1) {
      return flatMax;
    }

    return 1;
  }

  function isCartPage() {
    return document.body.classList.contains('template-cart');
  }

  function getMainCartSectionId() {
    var section = document.querySelector('[data-section-type="main-cart"]');
    if (section && section.dataset.sectionId) {
      return section.dataset.sectionId;
    }

    return 'main';
  }

  function hasPromoHookValue(selector) {
    return Array.from(document.querySelectorAll(selector)).some(function (el) {
      return (el.value || '').trim().length > 0;
    });
  }

  function cartNeedsPromoAction() {
    return hasPromoHookValue('.jsc-cart-gift-manual-remove');
  }

  function readCheckoutGate(root) {
    var scope = root || document;
    // Prefer main cart GWP section gate over drawer gate_only markup
    var gate =
      scope.querySelector('[data-manual-gwp] [data-manual-gwp-checkout-gate]') ||
      scope.querySelector('[data-manual-gwp-checkout-gate]');
    if (!gate) {
      return { blocked: false, message: '' };
    }

    return {
      blocked: gate.getAttribute('data-block') === 'true',
      message: gate.getAttribute('data-message') || '請先選擇您的滿額贈品'
    };
  }

  // SupaEasy Standard input: Cart attribute key = _Manual_GWP_Checkout_Block
  // Mirrors Liquid [data-manual-gwp-checkout-gate][data-block] via fetch only (no CartJS).
  var CHECKOUT_BLOCK_ATTR = '_Manual_GWP_Checkout_Block';
  var suppressCartSyncFromBlockAttr = false;
  var blockAttrSyncTimer = null;
  var blockAttrSyncPromise = null;

  function desiredCheckoutBlockAttrValue(state) {
    var gateState = state || readCheckoutGate();
    return gateState && gateState.blocked ? 'true' : '';
  }

  function syncCheckoutBlockCartAttribute(state) {
    var value = desiredCheckoutBlockAttrValue(state);
    var payload = {};
    payload[CHECKOUT_BLOCK_ATTR] = value;

    suppressCartSyncFromBlockAttr = true;

    blockAttrSyncPromise = fetch(cartRoot() + 'cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) {
          throw new Error('cart.js failed (' + res.status + ')');
        }
        return res.json();
      })
      .then(function (cart) {
        var current =
          cart.attributes && cart.attributes[CHECKOUT_BLOCK_ATTR] != null
            ? String(cart.attributes[CHECKOUT_BLOCK_ATTR])
            : '';

        if (current === value) {
          return null;
        }

        return fetch(cartRoot() + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          credentials: 'same-origin',
          body: JSON.stringify({ attributes: payload })
        }).then(function (updateRes) {
          return updateRes.text().then(function (bodyText) {
            if (!updateRes.ok) {
              var detail = bodyText;
              try {
                var parsed = JSON.parse(bodyText);
                detail = parsed.description || parsed.message || bodyText;
              } catch (e) {}
              throw new Error(
                'cart/update.js attributes failed (' + updateRes.status + '): ' + detail
              );
            }
          });
        });
      })
      .catch(function (err) {
        console.error('Manual GWP checkout-block attribute sync error:', err);
      })
      .then(function () {
        setTimeout(function () {
          suppressCartSyncFromBlockAttr = false;
          if (syncQueued) {
            syncQueued = false;
            scheduleCartSync();
          }
        }, 200);
      });

    return blockAttrSyncPromise;
  }

  function queueCheckoutBlockAttrSync(state) {
    var snapshot = {
      blocked: !!(state && state.blocked),
      message: (state && state.message) || ''
    };
    // When called without state, re-read gate after debounce settles
    var useLiveGate = !state;

    clearTimeout(blockAttrSyncTimer);
    blockAttrSyncTimer = setTimeout(function () {
      syncCheckoutBlockCartAttribute(useLiveGate ? readCheckoutGate() : snapshot);
    }, 250);
  }

  function applyCheckoutGateFromElement(gateEl) {
    var state;
    if (gateEl) {
      state = {
        blocked: gateEl.getAttribute('data-block') === 'true',
        message: gateEl.getAttribute('data-message') || '請先選擇您的滿額贈品'
      };
    } else {
      state = readCheckoutGate();
    }

    window.__jscManualGwpCheckoutGate = state;

    document.querySelectorAll('[data-manual-gwp-checkout-gate]').forEach(function (el) {
      el.setAttribute('data-block', state.blocked ? 'true' : 'false');
      el.setAttribute('data-message', state.message || '');
    });

    document.querySelectorAll('.btn.cart__checkout').forEach(function (btn) {
      if (btn.classList.contains('shopify-checkout-btn')) {
        return;
      }

      // Visual block only (no native disabled) so click can still show the require message
      if (state.blocked) {
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('is-manual-gwp-checkout-blocked');
      } else if (btn.classList.contains('is-manual-gwp-checkout-blocked')) {
        btn.removeAttribute('aria-disabled');
        btn.classList.remove('is-manual-gwp-checkout-blocked');
      }
    });

    document.querySelectorAll('.additional-checkout-buttons').forEach(function (el) {
      if (state.blocked) {
        el.style.display = 'none';
        el.setAttribute('data-manual-gwp-hidden', 'true');
      } else if (el.getAttribute('data-manual-gwp-hidden') === 'true') {
        el.style.display = '';
        el.removeAttribute('data-manual-gwp-hidden');
      }
    });

    if (!state.blocked) {
      setRequireBannersVisible(false);
    }

    // Attribute sync is queued separately (not inline) so ATC is not blocked mid-click
    return state;
  }

  function isCheckoutBlocked() {
    return window.__jscManualGwpCheckoutGate || readCheckoutGate();
  }

  function setRequireBannersVisible(visible) {
    document.querySelectorAll('[data-manual-gwp-require-banner]').forEach(function (banner) {
      if (visible) {
        banner.removeAttribute('hidden');
      } else {
        banner.setAttribute('hidden', '');
      }
    });
  }

  function showRequireBannerOnCheckoutAttempt() {
    var state = isCheckoutBlocked();
    if (!state || !state.blocked) {
      return false;
    }

    setRequireBannersVisible(true);

    var banner = document.querySelector('[data-manual-gwp-require-banner]');
    if (banner && typeof banner.scrollIntoView === 'function') {
      banner.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else if (!isCartPage()) {
      // Drawer has no gift UI — send customer to cart to select
      window.location.href = cartRoot() + 'cart';
    }

    return true;
  }

  function collectPromoLineKeys(selector) {
    var keys = [];
    document.querySelectorAll(selector).forEach(function (el) {
      var key = (el.value || '').trim();
      if (key) {
        keys.push(key);
      }
    });
    return keys;
  }

  async function executePromoCartActions() {
    var lineKeys = collectPromoLineKeys('.jsc-cart-gift-manual-remove');
    var uniqueLineKeys = Array.from(new Set(lineKeys));

    if (uniqueLineKeys.length === 0) {
      return false;
    }

    var updates = {};
    uniqueLineKeys.forEach(function (key) {
      updates[key] = 0;
    });

    var response = await fetch(cartRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    });

    if (!response.ok) {
      console.error('Failed to remove Manual GWP line items');
      return false;
    }

    return true;
  }

  async function refreshManualGwpSection() {
    if (!isCartPage()) {
      return false;
    }

    var container = document.querySelector('[data-manual-gwp]');
    if (!container) {
      return false;
    }

    var sectionId = getMainCartSectionId();
    var url = cartRoot() + 'cart?section_id=' + encodeURIComponent(sectionId) + '&t=' + Date.now();

    try {
      var response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) {
        return false;
      }

      var html = await response.text();
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var updated = parsed.querySelector('[data-manual-gwp]');

      if (updated) {
        container.innerHTML = updated.innerHTML;
        afterManualGwpDomRefresh(container.querySelector('[data-manual-gwp-checkout-gate]'));
        return true;
      }
    } catch (error) {
      console.error('Error refreshing Manual GWP section:', error);
    }

    return false;
  }

  async function rebuildCartProducts() {
    document.dispatchEvent(new CustomEvent('cart:build'));
  }

  async function checkManualGwpMax() {
    try {
      var response = await fetch(cartRoot() + 'cart.js');
      if (!response.ok) {
        return;
      }

      var cart = await response.json();
      var itemsByPromoTier = {};

      cart.items.forEach(function (item) {
        var properties = item.properties || {};
        if (properties['_Cart_GWP_Manual'] !== 'Free Gift') {
          return;
        }

        var promoNo = String(properties['_Cart_Gift_Manual'] || '');
        var tierNo = String(properties['_Cart_GWP_Tier'] || '1');
        if (!promoNo) {
          return;
        }

        var groupKey = promoNo + ':' + tierNo;
        if (!itemsByPromoTier[groupKey]) {
          itemsByPromoTier[groupKey] = { promoNo: promoNo, tierNo: tierNo, items: [] };
        }
        itemsByPromoTier[groupKey].items.push(item);
      });

      var updateList = {};

      Object.keys(itemsByPromoTier).forEach(function (groupKey) {
        var group = itemsByPromoTier[groupKey];
        var maxQty = getManualGwpMax(group.promoNo, group.tierNo);
        var promoItems = group.items;
        var totalQty = 0;

        promoItems.forEach(function (line) {
          totalQty += line.quantity;
        });

        if (totalQty <= maxQty) {
          return;
        }

        var excess = totalQty - maxQty;
        for (var j = promoItems.length - 1; j >= 0 && excess > 0; j--) {
          var lineItem = promoItems[j];
          if (lineItem.quantity <= excess) {
            updateList[lineItem.key] = 0;
            excess -= lineItem.quantity;
          } else {
            updateList[lineItem.key] = lineItem.quantity - excess;
            excess = 0;
          }
        }
      });

      if (Object.keys(updateList).length === 0) {
        return false;
      }

      await fetch(cartRoot() + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updateList })
      });

      return true;
    } catch (error) {
      console.error('Manual GWP max qty check error:', error);
      return false;
    }
  }

  async function syncCartAndPromo() {
    if (isSyncInProgress) {
      syncQueued = true;
      return;
    }

    isSyncInProgress = true;

    try {
      var promoChanged = false;

      await refreshManualGwpSection();

      if (cartNeedsPromoAction()) {
        promoChanged = await executePromoCartActions();
      }

      if (promoChanged) {
        await rebuildCartProducts();
        await refreshManualGwpSection();
      }

      var maxAdjusted = await checkManualGwpMax();
      if (maxAdjusted) {
        await rebuildCartProducts();
      }

      await refreshManualGwpSection();
    } catch (error) {
      console.error('Manual GWP sync error:', error);
    } finally {
      isSyncInProgress = false;
      if (syncQueued) {
        syncQueued = false;
        scheduleCartSync();
      } else {
        // After cart/promo settle: mirror gate → cart attribute
        queueCheckoutBlockAttrSync();
      }
    }
  }

  function scheduleCartSync() {
    if (suppressCartSyncFromBlockAttr) {
      syncQueued = true;
      return;
    }
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      if (suppressCartSyncFromBlockAttr) {
        syncQueued = true;
        return;
      }
      syncCartAndPromo();
    }, 50);
  }

  function afterManualGwpDomRefresh(gateEl) {
    initManualGwpScrollNav();
    var gateState = applyCheckoutGateFromElement(gateEl || null);
    queueCheckoutBlockAttrSync(gateState);
    return gateState;
  }

  function selectManualGwpVariant(button) {
    var card = button.closest('[data-manual-gwp-card]');
    if (!card) {
      return;
    }

    if (button.disabled || button.classList.contains('is-unavailable') || button.classList.contains('is-at-capacity')) {
      return;
    }

    card.querySelectorAll('.jsc-manual-gwp__variant').forEach(function (pill) {
      pill.classList.remove('is-active');
    });
    button.classList.add('is-active');

    var variantId = button.getAttribute('data-variant-id');
    var actions = card.querySelector('.jsc-manual-gwp__actions');
    var atc = card.querySelector('.jsc-gwp-grid-atc');

    if (actions) {
      actions.setAttribute('data-selected-variant-id', variantId);
    }

    if (atc) {
      atc.setAttribute('data-prod-id', variantId);
      atc.setAttribute('data-avail', button.getAttribute('data-variant-available'));
    }

    var variantImage = button.getAttribute('data-variant-image');
    if (variantImage) {
      var image = card.querySelector('.jsc-manual-gwp__image');
      if (image) {
        image.src = variantImage;
        if (image.srcset) {
          image.srcset = variantImage;
        }
      }
    }
  }

  async function addManualGwpToCart(el) {
    if (!el.classList.contains('cursor') || el.classList.contains('jsc-not-allowed')) {
      return;
    }

    if (el.getAttribute('data-gwp-at-capacity') === 'true') {
      return;
    }

    if (el.getAttribute('data-display-blocked') === 'true') {
      return;
    }

    if (el.getAttribute('data-avail') === 'false') {
      return;
    }

    var root = el.closest('.jsc-manual-gwp__actions');
    var variantId = (root && root.getAttribute('data-selected-variant-id')) || el.getAttribute('data-prod-id');
    var promoNo = el.getAttribute('data-promo') || (root && root.getAttribute('data-promo'));
    var tierNo = el.getAttribute('data-tier') || (root && root.getAttribute('data-tier'));

    if (!variantId || !promoNo || !tierNo) {
      return;
    }

    var maxQty = getManualGwpMax(promoNo, tierNo);

    var currentQty = parseInt((root && root.getAttribute('data-gwp-qty-total')) || '0', 10);
    if (Number.isNaN(currentQty) || currentQty < 0) {
      currentQty = 0;
    }

    if (currentQty >= maxQty) {
      return;
    }

    var gwpLabel = el.getAttribute('data-gwp-label');
    if (!gwpLabel && window.jscManualGwpLabel) {
      gwpLabel = window.jscManualGwpLabel[String(promoNo)] || '';
    }

    el.classList.remove('cursor');
    el.classList.add('jsc-not-allowed');
    var buttonText = el.querySelector('.btn');
    if (buttonText) {
      buttonText.textContent = '加入購物車...';
    }

    var properties = {
      _Cart_Gift_Manual: String(promoNo),
      _Cart_GWP_Tier: String(tierNo),
      _Cart_GWP_Manual: 'Free Gift'
    };

    if (gwpLabel) {
      properties._Manual_GWP_Label = gwpLabel;
    }

    var gwpDiscount = el.getAttribute('data-gwp-discount');
    if (gwpDiscount) {
      properties._Manual_GWP_Discount = gwpDiscount;
    }

    try {
      var response = await fetch(cartRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: parseInt(variantId, 10),
            quantity: 1,
            properties: properties
          }]
        })
      });

      if (!response.ok) {
        throw new Error('Failed to add Manual GWP');
      }

      await rebuildCartProducts();
      scheduleCartSync();
      queueCheckoutBlockAttrSync();
    } catch (error) {
      console.error('Manual GWP add error:', error);
      el.classList.add('cursor');
      el.classList.remove('jsc-not-allowed');
      if (buttonText) {
        buttonText.textContent = '加入購物車';
      }
    }
  }

  async function removeManualGwpFromCart(el) {
    var lineKey = el.getAttribute('data-line-key');
    if (!lineKey) {
      return;
    }

    el.disabled = true;

    try {
      var updates = {};
      updates[lineKey] = 0;

      var response = await fetch(cartRoot() + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });

      if (!response.ok) {
        throw new Error('Failed to remove Manual GWP');
      }

      await rebuildCartProducts();
      scheduleCartSync();
      queueCheckoutBlockAttrSync();
    } catch (error) {
      console.error('Manual GWP remove error:', error);
      el.disabled = false;
    }
  }

  function isManualGwpScrollLayout(container) {
    var desktop = container.getAttribute('data-layout-desktop') || 'stacked';
    var mobile = container.getAttribute('data-layout-mobile') || 'scroll';
    var isMobile = window.matchMedia('(max-width: 749px)').matches;

    return isMobile ? mobile === 'scroll' : desktop === 'scroll';
  }

  function initManualGwpScroll(container) {
    var wrap = container.querySelector('[data-manual-gwp-scroll]');
    var prev = container.querySelector('.jsc-manual-gwp__nav-btn--prev');
    var next = container.querySelector('.jsc-manual-gwp__nav-btn--next');

    if (!wrap || !prev || !next) {
      return;
    }

    function updateNavState() {
      if (!isManualGwpScrollLayout(container)) {
        prev.disabled = true;
        next.disabled = true;
        return;
      }

      var maxScroll = wrap.scrollWidth - wrap.clientWidth;

      if (maxScroll <= 1) {
        prev.disabled = true;
        next.disabled = true;
        return;
      }

      prev.disabled = wrap.scrollLeft <= 1;
      next.disabled = wrap.scrollLeft >= maxScroll - 1;
    }

    function scrollByDirection(direction) {
      var card = wrap.querySelector('.jsc-manual-gwp__card');
      var gap = 12;
      var amount = card ? card.offsetWidth + gap : Math.round(wrap.clientWidth * 0.85);

      wrap.scrollBy({
        left: direction * amount,
        behavior: 'smooth'
      });
    }

    prev.addEventListener('click', function () {
      if (!prev.disabled) {
        scrollByDirection(-1);
      }
    });

    next.addEventListener('click', function () {
      if (!next.disabled) {
        scrollByDirection(1);
      }
    });

    wrap.addEventListener('scroll', updateNavState, { passive: true });

    if (!window.__jscManualGwpScrollResizeBound) {
      window.__jscManualGwpScrollResizeBound = true;
      window.addEventListener('resize', function () {
        document.querySelectorAll('.jsc-choose-gwp-container').forEach(function (node) {
          var scrollWrap = node.querySelector('[data-manual-gwp-scroll]');
          var prevBtn = node.querySelector('.jsc-manual-gwp__nav-btn--prev');
          var nextBtn = node.querySelector('.jsc-manual-gwp__nav-btn--next');

          if (!scrollWrap || !prevBtn || !nextBtn) {
            return;
          }

          var maxScroll = scrollWrap.scrollWidth - scrollWrap.clientWidth;
          var scrollEnabled = isManualGwpScrollLayout(node) && maxScroll > 1;

          prevBtn.disabled = !scrollEnabled || scrollWrap.scrollLeft <= 1;
          nextBtn.disabled = !scrollEnabled || scrollWrap.scrollLeft >= maxScroll - 1;
        });
      });
    }

    updateNavState();
  }

  function initManualGwpScrollNav() {
    document.querySelectorAll('.jsc-choose-gwp-container').forEach(initManualGwpScroll);
  }

  function bindHandlers() {
    if (handlersBound) {
      return;
    }
    handlersBound = true;

    document.addEventListener('click', function (event) {
      var variantBtn = event.target.closest('.jsc-manual-gwp__variant');
      if (variantBtn) {
        event.preventDefault();
        selectManualGwpVariant(variantBtn);
        return;
      }

      var atcBtn = event.target.closest('.jsc-gwp-grid-atc.cursor');
      if (atcBtn) {
        event.preventDefault();
        addManualGwpToCart(atcBtn);
        return;
      }

      var removeBtn = event.target.closest('.jsc-gwp-remove-from-cart');
      if (removeBtn) {
        event.preventDefault();
        removeManualGwpFromCart(removeBtn);
      }
    });

    document.addEventListener('cart:updated', scheduleCartSync);
    document.addEventListener('cart:build', function () {
      scheduleCartSync();
    });
  }

  async function syncBeforeCheckout() {
    try {
      await refreshManualGwpSection();

      if (cartNeedsPromoAction()) {
        await executePromoCartActions();
        await rebuildCartProducts();
        await refreshManualGwpSection();
      }

      if (await checkManualGwpMax()) {
        await rebuildCartProducts();
      }

      await refreshManualGwpSection();
      applyCheckoutGateFromElement();
    } finally {
      clearTimeout(blockAttrSyncTimer);
      await syncCheckoutBlockCartAttribute(readCheckoutGate());
    }
  }

  function init() {
    bindHandlers();
    initManualGwpScrollNav();
    applyCheckoutGateFromElement();

    // Every page refresh: set or clear checkout-block attribute from current gate
    queueCheckoutBlockAttrSync();

    if (isCartPage()) {
      Promise.resolve(syncCartAndPromo()).then(function () {
        queueCheckoutBlockAttrSync();
      });
    }
  }

  window.scheduleCartSync = scheduleCartSync;
  window.jscManualGwpSyncBeforeCheckout = syncBeforeCheckout;
  window.jscManualGwpSyncCheckoutBlockAttr = function () {
    clearTimeout(blockAttrSyncTimer);
    return syncCheckoutBlockCartAttribute(readCheckoutGate());
  };
  window.jscManualGwpIsCheckoutBlocked = isCheckoutBlocked;
  window.jscManualGwpApplyCheckoutGate = applyCheckoutGateFromElement;
  window.jscManualGwpAfterDomRefresh = afterManualGwpDomRefresh;
  window.jscManualGwpShowRequireBanner = showRequireBannerOnCheckoutAttempt;
  window.addManualGwpToCart = addManualGwpToCart;
  window.removeManualGwpFromCart = removeManualGwpFromCart;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
